import React from "react";
import * as S from "../HomePage.style";
import { stmUser } from "src/common/types/stmUser";
import { SubSchedule } from "src/common/types/subSchedules";

interface MemberModalProps {
  member: stmUser | null;
  show: boolean;
  scheduleList?: SubSchedule[];
  onClose: () => void;
}

export const MemberModal = ({
  member,
  show,
  onClose,
  scheduleList,
}: MemberModalProps) => {
  if (!show || !member) return null;
  // console.log("MemberModal", member, scheduleList);
  return (
    <S.ModalOverlay onClick={onClose}>
      <S.ModalContent onClick={(e) => e.stopPropagation()}>
        <S.ModalHeader>
          <S.ModalTitle>팀멤버 정보</S.ModalTitle>
          <S.CloseButton onClick={onClose}>×</S.CloseButton>
        </S.ModalHeader>

        <S.MemberInfo>
          <S.MemberModalAvatar>👤</S.MemberModalAvatar>
          <S.MemberModalName>{member.userName}</S.MemberModalName>
          <div style={{ color: "#64748b", marginBottom: "20px" }}>
            <S.OnlineStatus style={{ marginRight: "8px" }} />
            온라인
          </div>

          <S.MemberDetail>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "8px 0",
              }}
            >
              <span style={{ fontWeight: 600, color: "#475569" }}>
                📱 연락처
              </span>
              <span style={{ color: "#1e293b" }}>
                {member.hp || "정보 없음"}
              </span>
            </div>
          </S.MemberDetail>
          <S.MemberDetail>
            <div
              style={{
                display: "flex",
                padding: "8px 0",
                fontSize: "2rem",
              }}
            >
              {scheduleList
                ?.filter((sub) => sub.assignedTo === member.oid)
                .map((sub) => sub.description)
                .join(", ")
                .toString() || "일정 없음"}
            </div>
          </S.MemberDetail>
        </S.MemberInfo>
      </S.ModalContent>
    </S.ModalOverlay>
  );
};
